import { AssociationsActions, AssociationsActionTypes } from '@clients/ngrx/actions/associations.actions';
import { ConfigService } from '@config/config.service';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { AssociationListResponse } from '@services/back-office/model/associationListResponse';
import { AssociationSearchRequest } from '@services/back-office/model/associationSearchRequest';
import { PaginationModel } from '@shared/models/pagination.model';

export const adapter: EntityAdapter<AssociationListResponse> = createEntityAdapter<AssociationListResponse>();

export interface State extends EntityState<AssociationListResponse> {
  loading: boolean,
  pagination: PaginationModel,
  filter: AssociationSearchRequest,
}

export const initialState: State = adapter.getInitialState({
  loading: false,
  pagination: {
    first: true,
    last: false,
    number: 0,
    numberOfElements: 0,
    size: new ConfigService().paginationConfig.pageSize,
    totalElements: 0,
  },
  filter: {archived: false},
});

export function reducer(state = initialState, action: AssociationsActions): State {
  switch (action.type) {
    /** Load Associations */
    case AssociationsActionTypes.LoadAssociations:
      return {...state, loading: !action.payload?.dontShowLoading};

    case AssociationsActionTypes.LoadAssociationsSuccess:
      return adapter.setAll(action.payload.content!, {
        ...state,
        loading: false,
        pagination: {
          size: action.payload.size,
          last: action.payload.last,
          totalElements: action.payload.totalElements,
          numberOfElements: action.payload.numberOfElements,
          first: action.payload.first,
          number: action.payload.number,
        },
      });

    case AssociationsActionTypes.LoadAssociationsFailure:
      return {...state, loading: false};

    /** Edit Association */
    case AssociationsActionTypes.EditAssociations:
      return {...state};

    case AssociationsActionTypes.EditAssociationsSuccess:
      return adapter.upsertOne(action.payload, {...state, loading: false});

    case AssociationsActionTypes.EditAssociationsFailure:
      return {...state};

    /** Change Page */
    case AssociationsActionTypes.ChangePage:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          number: action.payload.number,
          size: action.payload.size,
        }
      };

    /** Set Initial Pagination */
    case AssociationsActionTypes.SetInitialPagination:
      return {...state, pagination: initialState.pagination};

    /** Set Filter */
    case AssociationsActionTypes.SetFilter:
      return {...state, filter: action.payload};

    /** Clear Filter */
    case AssociationsActionTypes.ClearFilter:
      return {...state, filter: initialState.filter};

    /** Set Initial State */
    case AssociationsActionTypes.SetInitialState:
      return {...initialState};

    default:
      return state;
  }
}

export const {
  selectIds: selectAssociationsIds,
  selectEntities: selectAssociationsEntities,
  selectAll: selectAllAssociations,
  selectTotal: selectAssociationsTotal,
} = adapter.getSelectors();
